module.exports = __webpack_public_path__ + "img/image66.7d5bef36.jpg";